<template>
  <a-modal
    :title="title"
    :width="500"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="设备品牌" prop="supplierCode">
          <a-select v-model="form.supplierCode" placeholder="请选择设备品牌">
            <a-select-option
              :value="item.value"
              v-for="(item, index) in supplierCodeList"
              :key="index"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="设备名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入设备名称" />
        </a-form-model-item>
        <a-form-model-item label="设备序列号" prop="serialNumber">
          <a-input v-model="form.serialNumber" placeholder="请输入设备序列号" />
        </a-form-model-item>
        <a-form-model-item label="设备地点" prop="place">
          <a-select v-model="form.place" placeholder="请选择设备品牌">
            <a-select-option
              :value="item.value"
              v-for="(item, index) in placeList"
              :key="index"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="通道方向" prop="trafficDirection">
          <a-radio-group v-model="form.trafficDirection" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in config.trafficDirection"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Equipment } from "@/api";
export default {
  components: {},
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        supplierCode: undefined,
        name: "",
        serialNumber: "",
        place: undefined,
        trafficDirection: undefined,
      },
      form: {},
      supplierCodeList: [],
      placeList: [],
      rules: {
        supplierCode: [this.common.rulesReq("请选择设备品牌")],
        name: [
          {
            required: true,
            message: "请输入设备名称!",
            trigger: "change",
          },
        ],
        serialNumber: [
          {
            required: true,
            message: "请输入设备序列号!",
            trigger: "change",
          },
        ],
        place: [
          {
            required: true,
            message: "请选择设备地点!",
            trigger: "change",
          },
        ],
        trafficDirection: [
          {
            required: true,
            message: "请选择通道方向!",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑设备" : "添加设备";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      this.form.schoolId = this.$store.state.user.schoolId;
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        this.form.trafficDirection = data.trafficDirection + "";
        this.form.place = data.place + "";
        delete this.form.updateTime;
        delete this.form.createTime;
      }
      // 获取数据字典
      this.supplierCodeList = await this.common.getSysCodeType(
        "DEVICE_SUPPLIER_CODE"
      );
      this.placeList = await this.common.getSysCodeType("FACE_DEVICE_PLACE");
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          this.addsave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 添加提交
    addsave(data) {
      this.confirmLoading = true;
      Equipment.faceDeviceSave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "修改成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
